import { render, staticRenderFns } from "./product-list-sort.vue?vue&type=template&id=0683ea70&scoped=true&"
import script from "./product-list-sort.vue?vue&type=script&lang=js&"
export * from "./product-list-sort.vue?vue&type=script&lang=js&"
import style0 from "./product-list-sort.vue?vue&type=style&index=0&id=0683ea70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683ea70",
  null
  
)

export default component.exports